import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { AddCommentDialogComponent } from './add-comment-dialog/add-comment-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DeleteDocumentDialogComponent } from './delete-document-dialog/delete-document-dialog.component';
import { catchError, forkJoin, map, Observable, of, ReplaySubject, startWith, Subject, takeUntil } from 'rxjs';
import { AddDocumentDialogComponent } from './add-document-dialog/add-document-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectSearchModule } from 'mat-select-search';
import { CaseManagementService } from '../../service/case-management.service';
import { SharedCaseManagementService } from '../../shared/services/shared-case-management.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDivider } from '@angular/material/divider';
import { DateTime } from 'luxon';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { UserManagementService } from '../../service/user-management.service';

const DETERMINATION_IN_PROGRESS_STATUS = 'determination in progress';
const DETERMINATION_APPROVED_STATUS = 'determination approved';
const DETERMINATION_DENIED_STATUS = 'determination denied';
const DETERMINATION_LETTER_SENT_STATUS = 'determination letter sent';
const APPROVAL_LETTER_SENT_STATUS = 'approval letter sent';
const DENIAL_LETTER_SENT_STATUS = 'denial letter sent';
@Component({
  selector: 'app-case-detail',
  standalone: true,
  imports: [MatCardModule, CommonModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, MatInputModule, CommonModule, MatProgressSpinnerModule, MatIconModule,
    MatSelectSearchModule,MatAutocompleteModule, MatCheckboxModule, MatTooltipModule, MatRadioModule, MatDatepickerModule, MatDivider, MatTabsModule,MatBadgeModule
  ],
  providers: [
  { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] },
  { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
  { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  templateUrl: './case-detail.component.html',
  styleUrls: ['./case-detail.component.scss']
})

export class CaseDetailComponent implements OnInit {
  caseDetails: any;
  documentsList: any;
  historyList: any;
  caseView: any;
  caseForm: any;
  statusList: any[] = [];
  minDate: Date = new Date(1900, 0, 1); // Add this property for minimum date validation
  groupedStatusList: any[] = [];
  assigneeList = [
    {
      id: 1,
      name: '',
      role: 'Case Manager'
    }
  ];
  conditionsList: { id: any; name: any; description: any }[] = [];
  fsList: { name: any; eligibilityStartDate: any; eligibilityEndDate: any }[] = [];
  isLoading = true;
  documentsCreatedDates = [];
  historyCreatedDates = [];
  usersList: { first_name: string; last_name: string; role: string; user_id: number; }[] = [];
  currentCase: any;
  filteredAssigneesMulti: any;
  filteredAssignee: Observable<any[]> | undefined;
  /** Subject that emits when the component has been destroyed. */
  _onDestroy = new Subject<void>();
  reviewOptions: any;
  assessmentOptions: any;
  determinationOptions: any;
  currentCaseId: any= '';
  filteredAssigneeOptions: { id: number; name: string; role: string }[] = [];
  caseAdminAllowed: boolean = false;
  roles = 'ADMIN,CASE_MANAGER';
  isApplicationEditable: boolean = false;
  isConditionalEditVisible: boolean = false;
  isDeterminationLoading: boolean = false;
  determinationLetterLanguageOptions: any[] = [];
  isDeterminationDenied: boolean = false;
  activeTabIndex: number = 0;

  @ViewChild('singleSelect') singleSelect: MatSelect | undefined;
  @ViewChild('assigneeSearchInput') assigneeSearchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assigneeSelect') assigneeSelect!: MatSelect;
  constructor(
    private readonly router: Router, private readonly formBuilder: FormBuilder,
    private readonly dialog: MatDialog, private readonly toastr: ToastrService,
    private readonly caseManagementService: CaseManagementService,
    private readonly sharedCaseManagementService: SharedCaseManagementService,
    private readonly userManagementService: UserManagementService
  ) { }
  filterAssignee(name: string) {
    let arr = this.assigneeList.filter(
      (assignee) => assignee.name?.toLowerCase().startsWith(name.toLowerCase())
    );

    return arr.length ? arr : [{ name: 'No Item found', code: 'null' }];
  }
  ngOnInit() {
    this.caseDetails = [];
    this.documentsList = [];
    this.historyList = [];
    this.fsList = [];
    this.caseForm = this.formBuilder.group({
      status: ['', Validators.required],
      assignee: ['', Validators.required],
      assigneeMultiFilter: [''],
      assigneeSearchCtrl: [''],
      statusNotes: [''],
      assigneeNotes: [''],
      fsArr : [[]],
      eligibilityType: [''],
      isTemporaryEligibility: [''],
      eligibilityConditions: [[]],
      eligibilityTypeNote: [''],
      languageCode: [''],
      eligibilityStartDate: ['', Validators.required],
      eligibilityEndDate: ['', Validators.required],
      isOutOfServiceArea: ['']
    });
    this.caseForm.get('assigneeSearchCtrl').valueChanges.subscribe((searchText: string) => {
      const lower = searchText?.toLowerCase() || '';
      this.filteredAssigneeOptions = this.assigneeList.filter(
        assignee => assignee.name.toLowerCase().includes(lower)
      );
    });
    this.caseForm.get('status').valueChanges.subscribe((status: any) => {
      /*  12 : Determination in Progress
          13 : Determination Approved
          14 : Determination Denied
          15 : Determination Letter Sent
      */
    
      if (status && status.toLowerCase() === DETERMINATION_APPROVED_STATUS) {
        // Add required validators for conditional fields
        this.isConditionalEditVisible = true;
        this.isDeterminationDenied = false;
        this.caseForm.get('eligibilityType')?.setValidators([Validators.required]);
        this.caseForm.get('eligibilityConditions')?.setValidators([Validators.required]);
        this.caseForm.get('eligibilityTypeNote')?.setValidators([Validators.required]);
        this.caseForm.get('fsArr')?.setValidators([Validators.required]);
        if(this.currentCase?.eligibilityType!=null && this.currentCase?.eligibilityType!='null' && this.currentCase?.eligibilityType!='') {
          this.caseForm.get('eligibilityType')?.setValue(this.currentCase?.eligibilityType);
        }
        else {
          this.caseForm.get('eligibilityType')?.setValue('UNCONDITIONAL');
        }
        if(this.currentCase?.isTemporaryEligibility!=null && this.currentCase?.isTemporaryEligibility!='null' && this.currentCase?.isTemporaryEligibility!='') {
          this.caseForm.get('isTemporaryEligibility')?.setValue(this.currentCase?.isTemporaryEligibility);
        }
        else {
          this.caseForm.get('isTemporaryEligibility')?.setValue(0);
        }
        if(this.currentCase?.isOutOfServiceArea!=null && this.currentCase?.isOutOfServiceArea!='null' && this.currentCase?.isOutOfServiceArea!='') {
          this.caseForm.get('isOutOfServiceArea')?.setValue(this.currentCase?.isOutOfServiceArea);
        }
        else {
          this.caseForm.get('isOutOfServiceArea')?.setValue(0);
        }
        if(this.currentCase?.languageCode!=null && this.currentCase?.languageCode!='null' && this.currentCase?.languageCode!='') {
          this.caseForm.get('languageCode')?.setValue(this.currentCase?.languageCode);
        }
        else {
          this.caseForm.get('languageCode')?.setValue('en');
        }
        this.caseForm.get('eligibilityType')?.valueChanges.subscribe((value: any) => {
          if(value == 'CONDITIONAL') {
            this.caseForm.get('isTemporaryEligibility').setValue(this.currentCase?.isTemporaryEligibility || 0);
            this.caseForm.get('isTemporaryEligibility').disable();
          }
          else {
            this.caseForm.get('isTemporaryEligibility').setValue(this.currentCase?.isTemporaryEligibility || 0);
            if(this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_IN_PROGRESS_STATUS) {
              this.caseForm.get('isTemporaryEligibility').enable();
            }
            else {
              this.caseForm.get('isTemporaryEligibility').disable();
            }
          }
        });
        this.caseForm.get('isTemporaryEligibility')?.valueChanges.subscribe((value: any) => {
          if(value == 1) {
            this.caseForm.get('isOutOfServiceArea').setValue(this.currentCase?.isOutOfServiceArea || 0);
            this.caseForm.get('isOutOfServiceArea').disable();
          }
          else {
            this.caseForm.get('isOutOfServiceArea').setValue(this.currentCase?.isOutOfServiceArea || 0);
            if(this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_IN_PROGRESS_STATUS) {
              this.caseForm.get('isOutOfServiceArea').enable();
            }
            else {
              this.caseForm.get('isOutOfServiceArea').disable();
            }
          }
        });
      }
      else if(status && status.toLowerCase() === DETERMINATION_DENIED_STATUS) {
        this.isDeterminationDenied = true;
        if(this.currentCase?.languageCode!=null && this.currentCase?.languageCode!='null' && this.currentCase?.languageCode!='') {
          this.caseForm.get('languageCode')?.setValue(this.currentCase?.languageCode);
        }
        else {
          this.caseForm.get('languageCode')?.setValue('en');
        }
        this.isConditionalEditVisible = true;
      }
      else if (status && (status === DETERMINATION_LETTER_SENT_STATUS || status === APPROVAL_LETTER_SENT_STATUS || status === DENIAL_LETTER_SENT_STATUS)) {
        // Add or remove validators for specific fields
        this.isConditionalEditVisible = true;
        this.caseForm.get('eligibilityTypeNote')?.clearValidators();
        this.caseForm.get('eligibilityConditions')?.clearValidators();
        this.caseForm.get('eligibilityType')?.clearValidators();
        this.caseForm.get('fundingSourcesList')?.clearValidators();
        //this.caseForm.get('fsArr')?.clearValidators();
    
        // Disable conditional edit fields
        this.disableConditionalEditFields();
      } else {
        // Remove all validators for conditional fields
        this.isConditionalEditVisible = false;
        this.clearAllValidators();
      }
    });
    this.filteredAssignee = this.caseForm.get('assignee').valueChanges.pipe(
      startWith(''),
      map((assignee: any) =>
        assignee ? this.filterAssignee(assignee) : this.assigneeList.slice()
      )
    );
    
    this.filteredAssigneesMulti = new ReplaySubject<string | null>(1);

    this.sharedCaseManagementService.caseView$.subscribe((caseView) => {
      this.caseView = caseView;
    });
    this.sharedCaseManagementService.case$.subscribe((case1: any) => {
      this.currentCase = case1;
      this.caseView = 'view';
      this.caseAdminAllowed = !!(this.currentCase?.caseAdminAllowed || sessionStorage.getItem('caseAdminAllowed') == 'true');
      if(!this.caseAdminAllowed) {
        this.roles = 'ADMIN,CASE_MANAGER';
      }
      if(this.currentCase) {
        sessionStorage.setItem('caseId', this.currentCase?.caseId);
        sessionStorage.setItem('caseStatusId', this.currentCase?.caseStatusId);
        sessionStorage.setItem('caseAdminAllowed', String(this.caseAdminAllowed));
      }
      this.fetchAllData();
    });
  }
  
  fetchAllData() {
    this.isLoading = true;
    forkJoin(
      [
        this.caseManagementService.getWorkflowStatusById(this.currentCase?.caseStatusId || sessionStorage.getItem('caseStatusId') || ''),
        this.caseManagementService.getAssigneeDropdownData(this.roles),
        this.caseManagementService.getCaseDetails(this.currentCase?.caseId || sessionStorage.getItem('caseId')),
        this.caseManagementService.getAllDocuments(this.currentCase?.caseId || sessionStorage.getItem('caseId')),
        this.caseManagementService.getHistoryByCaseId(this.currentCase?.caseId || sessionStorage.getItem('caseId')),
        this.caseManagementService.getEligibilityConditions(),
        this.caseManagementService.getDeterminationLetterLanguages()
      ])
    .pipe(
      map(([workflowStatusDetails, assigneeDetails, caseDetails, documentDetails, historyDetails, eligibilityConditionsDetails, determinationLetterLanguages]) => {
        return { workflowStatusDetails, assigneeDetails, caseDetails, documentDetails, historyDetails, eligibilityConditionsDetails, determinationLetterLanguages };
      }),
      catchError((error) => of({ error }))
    )
    .subscribe((data: any) => {
      if(data && !data.error) {
        if ('workflowStatusDetails' in data) {
          this.statusList = data.workflowStatusDetails as any[];
          // Group statuses by 'statusGroup'
          this.groupedStatusList = this.groupStatusesByGroup(this.statusList);
        } else {
          console.error('Error fetching workflow status details:', data.error);
        }
        if ('assigneeDetails' in data) {
          this.assigneeList = Array.isArray(data.assigneeDetails)
            ? data.assigneeDetails.map((assignee: any) => ({
                id: assignee.userId, // Use userId as id
                name: `${assignee.firstName} ${assignee.lastName}`, // Combine firstName and lastName
                role: assignee.role || 'Unknown Role', // Provide a default or actual role
              }))
            : [];
          this.filteredAssigneeOptions = [...this.assigneeList as { id: number; name: string; role: string }[]];
          this.filteredAssigneesMulti.next(this.assigneeList.slice());
        } else {
          console.error('Error fetching assignee details:', data.error);
        }
        if ('caseDetails' in data) {
          this.caseDetails = data?.caseDetails;
          this.currentCase = this.caseDetails;
          this.currentCase.applicantName = this.caseDetails?.fullName;
          this.currentCase.caseCompletionStatus = this.caseDetails?.caseStatus;
          this.currentCase.caseCompletionGroupStatus = this.caseDetails?.caseStatusGroup;
          this.currentCase.assignee = this.caseDetails?.assignedToName;
          this.currentCase.caseStatusId = this.caseDetails?.caseStatusId;
          this.isApplicationEditable = this.caseDetails?.applicationEditable;
          this.currentCase.lastUpdatedDate = DateTime.fromISO(this.caseDetails?.caseUpdatedTime).toFormat('MM/dd/yyyy hh:mm a');
          this.caseForm.get('assigneeMultiFilter').valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterAssigneesMulti();
          });
          
          this.fsList = Array.isArray(this.caseDetails.fundingSources) ? this.caseDetails.fundingSources.map((source: any) => ({
            name: source?.fundingSourceName,
            eligibilityStartDate: getCurrentLocalDate(),
            eligibilityEndDate: getCurrentLocalDatePlusOneYear()
          })) : [];
          // Returns the user's current local date in yyyy-MM-dd format using Luxon
          function getCurrentLocalDate(): string {
            return DateTime.local().toFormat('yyyy-MM-dd');
          }

          // Returns the user's current local date plus one year in yyyy-MM-dd format using Luxon
          function getCurrentLocalDatePlusOneYear(): string {
            return DateTime.local().plus({ years: 1 }).toFormat('yyyy-MM-dd');
          }
          this.currentCase.eligibilityConditions = this.caseDetails?.eligibilityConditions;
          this.currentCase.eligibilityType = this.caseDetails?.eligibilityType;
          this.currentCase.isTemporaryEligibility = this.caseDetails?.isTemporaryEligibility || 0;
          this.currentCase.languageCode = this.caseDetails?.languageCode || 'en';
          this.currentCase.eligibilityTypeNote = this.caseDetails?.eligibilityTypeNote;
          this.currentCase.isOutOfServiceArea = this.caseDetails?.isOutOfServiceArea || 0;
          this.currentCase.eligibilityStartDate = DateTime.fromISO(this.fsList[0]?.eligibilityStartDate).toFormat('yyyy-MM-dd') || null;
          this.currentCase.eligibilityEndDate = DateTime.fromISO(this.fsList[0]?.eligibilityEndDate).toFormat('yyyy-MM-dd') || null;
          this.currentCase.fsArr = this.caseDetails?.fundingSources?.map((source: any) => source.fundingSourceName);
          if((this.currentCase?.fsArr?.length) && 
            (this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_APPROVED_STATUS) ||
            (this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_DENIED_STATUS) ||
            (this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS) ||
            (this.currentCase.caseStatus?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS ||
            (this.currentCase.caseStatus?.toLowerCase() == DENIAL_LETTER_SENT_STATUS)
          )
          ) {
            this.toggleSelectAllFundingSourcesConditions(this.currentCase.fsArr.length === this.fsList.length);
          }
          // Insert multiple object values into the fundingSources FormArray
          //this.insertFundingSources(this.caseDetails.fundingSources);

          this.caseForm.controls['status'].setValue(this.currentCase?.caseStatus);
          this.caseForm.controls['assignee'].setValue(this.currentCase?.assignedToId);
          this.caseForm.controls['eligibilityConditions'].setValue(this.currentCase?.eligibilityConditions || []);
          this.caseForm.controls['eligibilityType'].setValue(this.currentCase?.eligibilityType);
          this.caseForm.controls['isTemporaryEligibility'].setValue(this.currentCase?.isTemporaryEligibility);
          this.caseForm.controls['languageCode'].setValue(this.currentCase?.languageCode || 'en');
          this.caseForm.controls['eligibilityTypeNote'].setValue(this.currentCase?.eligibilityTypeNote);
          this.caseForm.controls['isOutOfServiceArea'].setValue(this.currentCase?.isOutOfServiceArea || 0);
          this.caseForm.controls['eligibilityStartDate'].setValue(this.currentCase?.eligibilityStartDate || '');
          this.caseForm.controls['eligibilityEndDate'].setValue(this.currentCase?.eligibilityEndDate || '');
          if(this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_APPROVED_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_DENIED_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS ||
            this.currentCase?.caseStatus?.toLowerCase() == DENIAL_LETTER_SENT_STATUS) {
            this.disableConditionalEditFields();
          }
          
        } else {
            console.error('Error fetching assignee details:', data.error);
            this.toastr.error('Could not fetch case details', '', { timeOut: 1000 });
            this.userManagementService.redirectToLogin(data.error,'');
        }
        if ('documentDetails' in data) {
          this.documentsList = data.documentDetails;
          this.documentsList?.forEach((document: any) => {
            document.createdDate = DateTime.fromISO(document.createdDate).toFormat('MM/dd/yyyy hh:mm a');
          });
        } else {
          console.error('Error fetching document details:', data.error);
          this.userManagementService.redirectToLogin(data.error,'');
        }
        if ('historyDetails' in data) {
          this.historyList = Array.isArray(data.historyDetails) ? data.historyDetails.map((history: any) => ({
            statusChanged: history?.description,
            notes: history?.remark,
            updatedDate: DateTime.fromISO(history?.updatedDate).toFormat('MM/dd/yyyy hh:mm a'),
            user: history?.remarkBy?.split(' (')[0], // Extract only the name before the role
          })) : [];
        }
        if('eligibilityConditionsDetails' in data) {
          this.conditionsList = Array.isArray(data.eligibilityConditionsDetails) ? data.eligibilityConditionsDetails.map((condition: any) => ({
            id: condition?.id,
            name: condition?.conditionName,
            description: condition?.description,
          })) : [];
          
          this.setSelectedConditions(data.caseDetails);
          this.currentCase.selectedFundingSources = data.caseDetails?.fundingSources || [];
        }
        if( 'determinationLetterLanguages' in data) {
          this.determinationLetterLanguageOptions = data.determinationLetterLanguages || [];
        }
      }
      if(data?.error) {
        console.error('Error in fetchAllData:', data.error);
        this.toastr.error('Could not fetch data', '', { timeOut: 1000 });
        this.userManagementService.redirectToLogin(data.error,'');
      }
      this.isLoading = false;
    },
    (error) => {
      console.error('Error in fetchAllData subscription:', error);
    }
  );
}

  groupStatusesByGroup(statusList: any[]) {
    const grouped: any[] = [];

    statusList.forEach(status => {
      const group = grouped.find(g => g.statusGroup === status.statusGroup);
      if (group) {
        group.statuses.push(status);
      } else {
        grouped.push({
          statusGroup: status.statusGroup,
          statuses: [status]
        });
      }
    });

    return grouped;
  }
  fetchCaseDetails() {
    this.isLoading = true;
    this.caseManagementService.getCaseDetails(this.currentCase?.caseId || sessionStorage.getItem('caseId')).subscribe({
      next: (caseDetails: any) => {
        if(caseDetails) {
          this.isLoading = false;
          this.currentCase = caseDetails;
          this.currentCase.applicantName = caseDetails?.fullName;
          this.currentCase.caseCompletionStatus = caseDetails?.caseStatus;
          this.currentCase.caseCompletionGroupStatus = caseDetails?.caseStatusGroup;
          this.currentCase.assigneeId = caseDetails?.assignedToId;
          this.currentCase.assignedToId = caseDetails?.assignedToId;
          this.currentCase.assignee = caseDetails?.assignedToName;
          this.currentCase.caseStatusId = caseDetails?.caseStatusId;
          this.currentCase.caseStatus = caseDetails?.caseStatus;
          this.currentCase.caseStatusGroup = caseDetails?.caseStatusGroup;
          this.currentCase.timeRemaining = caseDetails?.timeRemaining;
          this.currentCase.timeConsumedInPercentage = caseDetails?.timeConsumedInPercentage;
          this.currentCase.processId = caseDetails?.processId;
          this.currentCase.isApplicationEditable = caseDetails?.applicationEditable;
          this.currentCase.caseAdminAllowed = caseDetails?.caseAdminAllowed;
          this.isApplicationEditable = caseDetails?.applicationEditable;
          this.currentCase.lastUpdatedDate = DateTime.fromISO(caseDetails?.caseUpdatedTime).toFormat('MM/dd/yyyy hh:mm a');
          this.currentCase.fundingSources = caseDetails?.fundingSources;
          this.currentCase.eligibilityConditions = caseDetails?.eligibilityConditions;
          this.currentCase.eligibilityType = caseDetails?.eligibilityType;
          this.currentCase.isTemporaryEligibility = caseDetails?.isTemporaryEligibility || 0;
          this.currentCase.languageCode = caseDetails?.languageCode || 'en';
          this.currentCase.eligibilityTypeNote = caseDetails?.eligibilityTypeNote;
          this.currentCase.eligibilityStartDate = caseDetails?.fundingSources[0]?.eligibilityStartDate || null;
          this.currentCase.eligibilityEndDate = caseDetails?.fundingSources[0]?.eligibilityEndDate || null;
          this.currentCase.fsArr = this.caseForm.get('fsArr')?.value || [];
          this.currentCase.isOutOfServiceArea = caseDetails?.isOutOfServiceArea || 0;
          this.setSelectedConditions(caseDetails);
          this.setSelectedFundingSources(this.caseForm.get('fsArr')?.value);
          this.currentCase.selectedFundingSources = caseDetails?.fundingSources || [];
          if(this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_APPROVED_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_DENIED_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS || 
            this.currentCase?.caseStatus?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS ||
            this.currentCase?.caseStatus?.toLowerCase() == DENIAL_LETTER_SENT_STATUS) {
            this.disableConditionalEditFields();
          }
        }
      },
      error:(error) => {
        console.error('Error fetching case details:', error);
        this.toastr.error('Could not fetch case details', '', { timeOut: 1000 });
        this.isLoading = false;
        this.userManagementService.redirectToLogin(error,'');
      }
    });
  }

  fetchAllDocuments() {
    this.isLoading = true;
    this.caseManagementService.getAllDocuments(this.currentCase.caseId).subscribe({
      next: (documentsData: any) => {
        this.isLoading = false;
        if(documentsData) {
          this.documentsList = documentsData;
          this.documentsList.forEach((document: any) => {
            document.createdDate = DateTime.fromISO(document.createdDate).toFormat('MM/dd/yyyy hh:mm a');
          });
        }
      },
      error: (error) => {
        console.error('Error fetching documents:', error);
        this.toastr.error('Could not fetch documents', '', { timeOut: 1000 });
        this.isLoading = false;
      }
    });
  }
  fetchAllHistory() {
    this.isLoading = true;
    this.caseManagementService.getHistoryByCaseId(this.currentCase.caseId).subscribe({
      next: (historyData: any) => {
        if(historyData) {
          this.isLoading = false;
          this.historyList = Array.isArray(historyData) ? historyData?.map((history: any) => ({
            statusChanged: history?.description,
            notes: history?.remark,
            updatedDate: DateTime.fromISO(history?.updatedDate).toFormat('MM/dd/yyyy hh:mm a'),
            user: history?.remarkBy,
          })) : [];
        }
      },
      error: (error) => {
        console.error('Error fetching history:', error);
        this.toastr.error('Could not fetch history', '', { timeOut: 1000 });
        this.isLoading = false;
      }
    });
  }
  backToCaseList() {
    this.router.navigate(['/case-list']);
  }
  navigateToApplicationForm() {
    this.router.navigate(['/application-form'], {
      queryParams: { id: 27 },
      state: { 'previewForm': true, 'caseView': this.caseView }
    });
  }
  downloadDocument(documentObj: any): void {
    this.caseManagementService.downloadDocument(this.currentCase?.caseId, documentObj.id).subscribe({
      next: (response: Blob) => {
        let documentType = documentObj.path?.substring(documentObj.path?.lastIndexOf('.') + 1);
        // Creating a temporary link to trigger the download
        const fileURL = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = documentObj?.name + '.'+ documentType;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(fileURL);
        this.toastr.success(`Document download started ...`, '', {
          timeOut: 1000,
        });
      },
      error: (error) => {
        console.error('Error downloading document:', error);
        this.toastr.error('Could not download the document', '', { timeOut: 1000 });
        this.userManagementService.redirectToLogin(error,'');
      }
    });
  }
  viewDocument(documentObj: any) {
    this.caseManagementService.viewDocument(this.currentCase?.caseId, documentObj.id).subscribe({
      next: (response: Blob) => {
        const fileURL = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = fileURL;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileURL);
      },
      error: (error) => {
        console.error('Error viewing document:', error);
        this.toastr.error('Could not view the document', '', { timeOut: 1000 });
        this.userManagementService.redirectToLogin(error,'');
      }
    });
  }
  clearAllValidators() {
    this.caseForm.get('eligibilityTypeNote')?.clearValidators();
    this.caseForm.get('eligibilityConditions')?.clearValidators();
    this.caseForm.get('eligibilityType')?.clearValidators();
    this.caseForm.get('fsArr')?.clearValidators();
    // Update validity after clearing validators
    this.caseForm.get('eligibilityTypeNote')?.updateValueAndValidity();
    this.caseForm.get('eligibilityConditions')?.updateValueAndValidity();
    this.caseForm.get('eligibilityType')?.updateValueAndValidity();
    this.caseForm.get('fsArr')?.updateValueAndValidity();
  }
  isDateValidArr: any[] = [];
  isDateValid: boolean = true;
  checkFSValidation() {

    const startDate = this.caseForm.get('eligibilityStartDate')?.value;
    const endDate = this.caseForm.get('eligibilityEndDate')?.value;

    if (!startDate) {
      this.isDateValid = false;
      this.caseForm.get('eligibilityStartDate')?.setErrors({ required: true });
      this.caseForm.get('eligibilityStartDate')?.markAsTouched();
      this.toastr.error(`Eligibility start date is required.`);
      return;
    }
    if (!endDate) {
      this.isDateValid = false;
      this.caseForm.get('eligibilityEndDate')?.setErrors({ required: true });
      this.caseForm.get('eligibilityEndDate')?.markAsTouched();
      this.toastr.error(`Eligibility end date is required.`);
      return;
    }
    if (startDate && endDate && DateTime.fromJSDate(new Date(startDate)).toUTC().toFormat('yyyy-MM-dd') > DateTime.fromJSDate(new Date(endDate)).toUTC().toFormat('yyyy-MM-dd')) {
        this.isDateValid = false;
        this.caseForm.get('eligibilityStartDate')?.setErrors({ invalidDateRange: true });
        this.caseForm.get('eligibilityStartDate')?.markAsTouched();
        this.toastr.error(`Eligibility start date cannot be greater than eligibility end date.`);
    }
    else {
        this.isDateValid = true;
        this.caseForm.get('eligibilityStartDate')?.setErrors(null);
        this.caseForm.get('eligibilityEndDate')?.setErrors(null);
        this.caseForm.get('eligibilityStartDate')?.markAsUntouched();
        this.caseForm.get('eligibilityEndDate')?.markAsUntouched();
        this.caseForm.get('eligibilityStartDate')?.updateValueAndValidity();
        this.caseForm.get('eligibilityEndDate')?.updateValueAndValidity();
      }
  }
  
  updateCase() {
    if(this.caseForm.get('assignee')?.value == '' || this.caseForm.get('assignee')?.value == null) {
      this.caseForm.get('assignee')?.setErrors({ required: true });
      this.caseForm.get('assignee')?.markAsTouched();
      this.toastr.error('Assignee is required.');
      return;
    }
    // Validate only for determination approved status
    if(this.caseForm.get('status').value?.toLowerCase() == DETERMINATION_APPROVED_STATUS) {
      this.caseForm.get('statusNotes')?.clearValidators();
      // Mark all controls as touched to trigger validation messages
      this.caseForm.markAllAsTouched();
      this.caseForm.get('statusNotes')?.markAsUntouched();
      // Check if the form is valid
      if (this.caseForm.invalid) {
        // Check individual form control statuses
        const eligibilityTypeControl = this.caseForm.get('eligibilityType');
        const eligibilityConditionsControl = this.caseForm.get('eligibilityConditions');
        const eligibilityTypeNoteControl = this.caseForm.get('eligibilityTypeNote');
        if(this.caseForm.get('fsArr')?.invalid) {
          this.toastr.error('Funding sources are required.');
        }
        if(eligibilityTypeControl.value == 'CONDITIONAL') {
          this.caseForm.get('eligibilityConditions')?.setValidators([Validators.required]);
          this.caseForm.get('eligibilityTypeNote')?.setValidators([Validators.required]);
          this.caseForm.get('eligibilityConditions')?.updateValueAndValidity();
          this.caseForm.get('eligibilityTypeNote')?.updateValueAndValidity();
          if (eligibilityConditionsControl?.invalid) {
            console.error('Eligibility Conditions are invalid:', eligibilityConditionsControl.errors);
            this.toastr.error('Please select at least one eligibility condition');
          }
  
          if (eligibilityTypeNoteControl?.invalid) {
            console.error('Eligibility Type Note is invalid:', eligibilityTypeNoteControl.errors);
            this.toastr.error('Conditional comments is required.');
          }
        }
        else {
          this.caseForm.get('eligibilityConditions')?.clearValidators();
          this.caseForm.get('eligibilityTypeNote')?.clearValidators();
          this.caseForm.get('eligibilityConditions')?.updateValueAndValidity();
          this.caseForm.get('eligibilityTypeNote')?.updateValueAndValidity();
        }
        this.checkFSValidation();
        if(!this.isDateValid) {
          return;
        }
        if(this.caseForm.invalid) {
          return; // Stop further execution if the form is invalid
        }
      }
      
      if(this.currentCase?.caseStatus == this.caseForm.get('status')?.value) {
        this.toastr.error("Determination Approved status can be saved only once");
        return;
      }
      this.checkFSValidation();
      if(!this.isDateValid) {
        return;
      }
    }
    else if(this.caseForm.get('status').value?.toLowerCase() == DETERMINATION_DENIED_STATUS) {
      if(this.caseForm.get('statusNotes').value == '') {
        this.caseForm.get('statusNotes')?.setValidators([Validators.required]);
        this.caseForm.get('statusNotes')?.updateValueAndValidity();
        this.caseForm.get('statusNotes')?.markAsTouched();
        this.toastr.error('Status notes are required for Determination Denied status');
        return;
      }
    }
    else {
      this.caseForm.get('statusNotes')?.markAsUntouched();
      // Clear validators for conditional fields if status is not 13
      this.clearAllValidators();
    }
    if(this.currentCase.caseStatus == this.caseForm.value.status
      && this.currentCase.assignedToId == this.caseForm.value.assignee
    ) {
      this.toastr.warning('Please enter either status or assignee to update the case', '', { timeOut: 2000 });
    } else {
      this.caseView = 'view';
      this.isLoading = true;
      let caseCompletionStatus = this.statusList.find((status) => status.status == this.caseForm.value.status);
      let assigneeStatus = this.assigneeList.find((assignee) => assignee.id == this.caseForm.value.assignee);
      let reqBody =  
      {
        "caseId": 0,
        "assignedById": 0,
        "assignedByName": "",
        "currentTaskAssigneeId": 0,
        "currentTaskAssigneeName": "",
        "nextTaskAssigneeId": 0,
        "nextTaskAssigneeName": "",
        "fromStatusId": 0,
        "fromStatus": "",
        "toStatusId": 0,
        "toStatus": "",
        "toStatusGroup": "",
        "processId": 0,
        "assigneeNote": "",
        "statusNote": "",
        "updatedDate": "",
        "applicationEditable": false,
        "caseAdminAllowed": false,
        "fundingSources": [],
        "eligibilityConditions": [],
        "eligibilityType": "",
        "eligibilityTypeNote": "",
        "isTemporaryEligibility": 0,
        "isOutOfServiceArea": 0,
        "languageCode": 'EN'
      }
        /* "caseId": current case id,
        "assignedById": login person id,
        "currentTaskAssigneeId": current assignee id,
        "currentTaskAssigneeName": current assignee name
        "nextTaskAssigneeId": next assignee id changed in assignee dropdown,
        "nextTaskAssigneeName": next assignee name changed in assignee dropdown
        "fromStatusId": current status id,
        "fromStatus": "review in progress",
        "toStatusId": next status id,
        "toStatus": "review done",
        "processId": 0,
        "assigneeNote": status notes
        "statusNote": assignee notes 
        "updatedDate": last updated date,
        "applicationEditable": is application editable,
        "caseAdminAllowed": is user a admin
        "fundingSources": list of funding sources with respective start and end dates
        "eligibilityConditions": list of condtions
        "eligibilityType": is approval conditional,
        "eligibilityTypeNote": conditional comments,
        "isTemporaryEligibility": is temporary eligibility,
        "fsArr": static funding sources,
        "isOutOfServiceArea": is out of service area,
        "languageCode": language for determination letter
        */
      reqBody.caseId = this.currentCase.caseId;
      reqBody.assignedById = Number(sessionStorage.getItem('userId')) || 0;
      reqBody.currentTaskAssigneeId = this.currentCase?.assignedToId;
      reqBody.currentTaskAssigneeName = this.currentCase?.assignee;
      reqBody.nextTaskAssigneeId = this.caseForm.value?.assignee;
      reqBody.nextTaskAssigneeName = assigneeStatus?.name ?? '';
      reqBody.fromStatusId = this.currentCase?.caseStatusId;
      reqBody.fromStatus = this.currentCase?.caseCompletionStatus;
      reqBody.toStatusId = caseCompletionStatus?.id;
      reqBody.toStatus = this.caseForm.value?.status;
      reqBody.processId = 0;
      reqBody.assigneeNote = this.caseForm.value?.assigneeNotes;
      reqBody.statusNote = this.caseForm.value?.statusNotes;
      reqBody.fundingSources = [];
      // Set eligibility conditions only if the status is 13 (Determination Approved)
      if(this.caseForm.value?.status?.toLowerCase() == DETERMINATION_APPROVED_STATUS || this.caseForm?.value?.status?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS || this.caseForm?.value?.status?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS || this.caseForm?.value?.status?.toLowerCase() == DENIAL_LETTER_SENT_STATUS) {
        this.setSelectedFundingSources(this.caseForm.get('fsArr')?.value);
        // If value is a Luxon DateTime object, use toFormat; if string, parse then format
        const startDateValue = this.caseForm.get('eligibilityStartDate')?.value;
        const endDateValue = this.caseForm.get('eligibilityEndDate')?.value;
        
        let formattedStartDate = '';
        let formattedEndDate = '';
        if (startDateValue && typeof startDateValue.toFormat === 'function') {
          // It's a Luxon DateTime object
          formattedStartDate = startDateValue.toFormat('yyyy-MM-dd');
        } else if (typeof startDateValue === 'string') {
          // Try to parse as yyyy-MM-dd string
          formattedStartDate = DateTime.fromFormat(startDateValue, 'yyyy-MM-dd').toFormat('yyyy-MM-dd');
        }
        if (endDateValue && typeof endDateValue.toFormat === 'function') {
          // It's a Luxon DateTime object
          formattedEndDate = endDateValue.toFormat('yyyy-MM-dd');
        } else if (typeof endDateValue === 'string') {
          // Try to parse as yyyy-MM-dd string
          formattedEndDate = DateTime.fromFormat(endDateValue, 'yyyy-MM-dd').toFormat('yyyy-MM-dd');
        }
        reqBody.fundingSources = (this.caseForm.get('fsArr')?.value || []).map((fs: any) => ({
          fundingSourceName: fs,
          eligibilityStartDate: formattedStartDate,
          eligibilityEndDate: formattedEndDate
        }));
        if(this.currentCase?.fundingSources && this.currentCase.fundingSources.length > 0) {
          this.currentCase.fundingSources[0].eligibilityStartDate = formattedStartDate;
          this.currentCase.fundingSources[0].eligibilityEndDate = formattedEndDate;
        }
        reqBody.eligibilityConditions = this.caseForm.get('eligibilityType').value == 'CONDITIONAL' ? this.caseForm.get('eligibilityConditions')?.value : [];
        reqBody.eligibilityType = this.caseForm.get('eligibilityType')?.value;
        reqBody.eligibilityTypeNote = this.caseForm.get('eligibilityType').value == 'CONDITIONAL' ? this.caseForm.get('eligibilityTypeNote')?.value : '';
        reqBody.isTemporaryEligibility = this.caseForm.get('isTemporaryEligibility')?.value || 0;
        reqBody.isOutOfServiceArea = this.caseForm.get('isOutOfServiceArea')?.value || 0;
      }
      else {
        this.caseForm.get('eligibilityConditions').setValue([]);
        this.caseForm.get('eligibilityType').setValue('');
        this.caseForm.get('eligibilityTypeNote').setValue('');
        reqBody.fundingSources = [];
        reqBody.eligibilityConditions = [];
        reqBody.eligibilityType = '';
        reqBody.eligibilityTypeNote = '';
        reqBody.isTemporaryEligibility = 0;
        reqBody.isOutOfServiceArea = 0;
      }
      reqBody.languageCode = this.caseForm.get('languageCode')?.value || 'en';
      if(reqBody.toStatusId == 13) {
        this.isDeterminationLoading = true;
      }
      this.setSelectedConditions(this.caseForm.get('eligibilityConditions')?.value || []);
      
      this.caseManagementService.assignCaseToUser(reqBody, this.currentCase.caseId).subscribe({
        next: (response: any) => {
          if(response) {
            this.isLoading = false;
            this.isDeterminationLoading = false;
            this.currentCase.caseId = response?.caseId; 
            this.fetchCaseDetails();
            this.fetchAllHistory();
            this.fetchStatuses(response?.toStatusId);
            this.toastr.success('Case updated successfully', '', { timeOut: 1000 });
          }
        },
        error: (error) => {
          console.error('Error updating case:', error);
          this.isLoading = false;
          this.isDeterminationLoading = false;
          this.toastr.error('Failed to update case. Please try again.');
          this.userManagementService.redirectToLogin(error,'');
        }
      });
    }
  }
  addComment() {
    const dialogRef = this.dialog.open(AddCommentDialogComponent, {
      width: '40rem',
      minWidth: '24rem',
      height: '18rem',
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.isLoading = true;
        this.caseManagementService.saveComments(this.currentCase.caseId, result).subscribe({
          next: (response: any) => {
            this.fetchAllHistory();
            this.isLoading = false;
            this.toastr.success('Comment added successfully', '', { timeOut: 1000 });
          },
          error: (error) => {
            console.error('Error adding comment:', error);
            this.isLoading = false;
            this.toastr.error('Failed to add comment. Please try again.');
            this.userManagementService.redirectToLogin(error,'');
          }
        });
      }
    });
  }
  addDocument() {
    const dialogRef = this.dialog.open(AddDocumentDialogComponent, {
      width: '28rem',
      minWidth: '28rem',
      minHeight: '20rem',
      maxHeight: '30rem',
      data: { documentsList: this.documentsList, currentCase: this.currentCase }
    });
    dialogRef.afterClosed().subscribe((result: File[]) => {
      this.isLoading = true;
      if (result && result?.length > 0) {
        const formData = new FormData();
        result.forEach(file => {
          formData.append('files', file, file.name);
        });
        this.caseManagementService.addDocument(this.currentCase.caseId, formData).subscribe({
          next: (response: any) => {
            this.isLoading = false;
            this.toastr.success(result.length + ' files uploaded successfully');
            this.fetchAllDocuments(); // Refresh the documents list
            this.fetchAllHistory(); // Refresh the history list
          },
          error: (error) => {
            this.isLoading = false;
            this.toastr.error('Failed to upload document. Please try again.');
            this.userManagementService.redirectToLogin(error,'');
            console.error(error);
          }
        });
      } else {
        this.isLoading = false;
      }
    });
  }
  deleteDocument(documentId: string) {
    const dialogRef = this.dialog.open(DeleteDocumentDialogComponent, {
      width: '30rem',
      minWidth: '24rem',
      height: '12rem',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoading = true;
        this.caseManagementService.deleteDocument(this.currentCase.caseId, documentId).subscribe({
          next: (response: any) => {
            this.toastr.success('Document deleted successfully');
            this.fetchAllDocuments();
            this.fetchAllHistory();
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Error deleting document:', error);
            this.toastr.error('Failed to delete document. Please try again.');
            this.userManagementService.redirectToLogin(error,'');
            this.isLoading = false;
          }
        });
      }
    });
  }
  editInformation() {
    this.caseView = 'edit';
    if(this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_APPROVED_STATUS || 
      this.currentCase?.caseStatus?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS || 
      this.currentCase?.caseStatus?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS
      || this.currentCase?.caseStatus?.toLowerCase() == DENIAL_LETTER_SENT_STATUS) {
        this.isConditionalEditVisible = true;
        this.disableConditionalEditFields();
  }
    
    this.sharedCaseManagementService.caseView.next(this.caseView);
  }
  disableConditionalEditFields() {
    this.caseForm.get('eligibilityType').disable();
    this.caseForm.get('eligibilityConditions').disable();
    this.caseForm.get('eligibilityTypeNote').disable();
    this.caseForm.get('isTemporaryEligibility').disable();
    this.caseForm.get('languageCode').disable();
    this.caseForm.get('fsArr').disable();
    this.caseForm.get('eligibilityStartDate').disable();
    this.caseForm.get('eligibilityEndDate').disable();
    this.caseForm.get('isOutOfServiceArea').disable();
    this.caseForm.clearValidators();
  }
  fetchStatuses(toStatusId: any) {
    if (!toStatusId) {
      console.warn('Invalid toStatusId provided for fetching statuses.');
      return;
    }
    this.isLoading = true;
    this.caseManagementService.getWorkflowStatusById(toStatusId).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response) {
          this.statusList = response as any[]; // Assign the response to `statusList`
          this.groupedStatusList = this.groupStatusesByGroup(this.statusList);
        } else {
          this.isLoading = false;
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error fetching workflow status:', error);
        this.toastr.error('Failed to fetch workflow status. Please try again.');
      }
    });
  }

  viewApplication(view: any,caseId: any): void {
    //const currentUrl = window.location.origin + '/preview-application-form'; use in local
    const currentUrl = window.location.origin + '/eligibility/preview-application-form';
    localStorage.setItem('caseView', view);
    localStorage.setItem('caseId', caseId);
    this.sharedCaseManagementService.changeCase(this.currentCase);
    window.open(currentUrl, '_blank');
  }
  filterAssigneesMulti() {
    if (!this.assigneeList) {
      return;
    }
    // get the search keyword
    let search = this.caseForm.get('assigneeMultiFilter').value;
    if (!search) {
      this.filteredAssigneesMulti.next(this.assigneeList.slice());
      return;
    } else {
      search = search?.toLowerCase();
    }
    this.filteredAssigneesMulti.next(
      this.assigneeList
      .filter(assignee => {
        return assignee.name?.toLowerCase().includes(search);
      })
    );
  }
  cancelEdit() {
    this.caseView = 'view';
  }
  getProgressBarStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedCaseManagementService.getProgressBarStyles(timeConsumedInPercentage);
  }

  getProgressBarContainerStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedCaseManagementService.getProgressBarContainerStyles(timeConsumedInPercentage);
  }
  getProgressBackgroundStyles(timeConsumedInPercentage: number): { [key: string]: string } {
    return this.sharedCaseManagementService.getProgressBackgroundStyles(timeConsumedInPercentage);
  }
  getCombinedProgressStyles(percent: number): { [key: string]: string } {
    return {
      ...this.getProgressBarContainerStyles(percent),
      ...this.getProgressBackgroundStyles(percent)
    };
  }
  clearAssigneeSearch() {
    this.caseForm.get('assigneeSearchCtrl').setValue('');
    this.filteredAssigneeOptions = [...this.assigneeList];
  }
  clearFormData() {
    this.caseView = 'view';
    if(this.currentCase.caseStatus?.toLowerCase() == DETERMINATION_LETTER_SENT_STATUS || this.currentCase.caseStatus?.toLowerCase() == APPROVAL_LETTER_SENT_STATUS || this.currentCase.caseStatus?.toLowerCase() == DENIAL_LETTER_SENT_STATUS) {
      this.isConditionalEditVisible = true;
    }
    else {
      this.isConditionalEditVisible = false;
    }
    this.caseForm.controls['status'].setValue(this.currentCase?.caseStatus);
    this.caseForm.controls['assignee'].setValue(this.currentCase?.assignedToId);
    this.caseForm.controls['statusNotes'].setValue('');
    this.caseForm.controls['assigneeNotes'].setValue('');
    this.caseForm.controls['eligibilityType'].setValue(this.currentCase?.eligibilityType);
    this.caseForm.controls['eligibilityConditions'].setValue(this.currentCase?.eligibilityConditions || []);
    this.caseForm.controls['eligibilityTypeNote'].setValue(this.currentCase?.eligibilityTypeNote || '');
    this.caseForm.clearValidators();
  }
  isTextTruncated(): boolean {
    const element = document.querySelector('.document-name') as HTMLElement;
    if (element) {
      return element.offsetWidth < element.scrollWidth;
    }
    return false;
  }
  get allConditionsSelected(): boolean {
    const selected = this.caseForm.get('eligibilityConditions')?.value || [];
    return selected.length === this.conditionsList.length;
  }
  get allFundingSourcesSelected(): boolean {
    const selected = this.caseForm.get('fsArr')?.value || [];
    return selected.length === this.fsList.length;
  }
  
  someConditionsSelected(): boolean {
    const selected = this.caseForm.get('eligibilityConditions')?.value || [];
    return selected.length > 0 && selected.length < this.conditionsList.length;
  }
  someFundingSourcesSelected(): boolean {
    const selected = this.caseForm.get('fsArr')?.value || [];
    return selected.length > 0 && selected.length < this.fsList.length;
  }
  
  toggleSelectAllConditions(checked: boolean) {
    if (checked) {
      this.caseForm.get('eligibilityConditions')?.setValue(this.conditionsList.map(c => c.id));
    } else {
      this.caseForm.get('eligibilityConditions')?.setValue([]);
    }
  }
  toggleSelectAllFundingSourcesConditions(checked: boolean) {
    if (checked) {
      this.caseForm.get('fsArr')?.setValue(this.fsList.map(c => c.name));
    } else {
      this.caseForm.get('fsArr')?.setValue([]);
    }
  }
  setSelectedConditions(caseDetails: any) {
    this.currentCase.selectedConditions = [];
    this.conditionsList?.forEach((condition: any) => {
      if (caseDetails.eligibilityConditions?.includes(condition.id)) {
        this.currentCase.selectedConditions.push({
          id: condition.id,
          name: condition.name,
          description: condition.description
        });
      }
    });
  }
  setSelectedFundingSources(fundingSources: any) {
    this.currentCase.selectedFundingSources = [];
    this.fsList?.forEach((source: any) => {
      if (fundingSources?.includes(source.name)) {
        this.currentCase.selectedFundingSources.push({
          name: source.name
        });
      }
    });
  }
  focusAssigneeSearch() {
    setTimeout(() => {
      this.assigneeSearchInput?.nativeElement.focus();
    }, 0);
  }
  onSearchKeyDown(event: KeyboardEvent, matSelect: MatSelect) {
    if (event.key === 'ArrowDown') {
      event.preventDefault(); 
      const panel = matSelect.panel?.nativeElement;
      if (panel) {
        const firstOption = panel.querySelector('mat-option');
        (firstOption as HTMLElement)?.focus();
      }
    }
  }
  onOptionsKeydown(event: KeyboardEvent) {
    const options = Array.from(
      (event.currentTarget as HTMLElement).querySelectorAll('mat-option')
    ) as HTMLElement[];
  
    const focusedIndex = options.findIndex(opt => opt.classList.contains('mat-active'));
  
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = (focusedIndex + 1) % options.length;
      options[nextIndex]?.focus();
    }
  
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = (focusedIndex - 1 + options.length) % options.length;
      options[prevIndex]?.focus();
    }
  }
  getConditionsTooltip(): string {
    const selectedIds = this.caseForm.get('eligibilityConditions')?.value || [];
    const selectedConditions = this.conditionsList
      .filter(option => selectedIds.includes(option.id))
      .map(option => option.name);
    return selectedConditions.length > 0 ? selectedConditions.join(', ') : ''; // Return an empty string if no options are selected
  }
  getFundingSourcesTooltip(): string {
    const selectedIds = this.caseForm.get('fsArr')?.value || [];
    const selectedFundingSources = this.fsList
      .filter(option => selectedIds.includes(option.name))
      .map(option => option.name);
    return selectedFundingSources.length > 0 ? selectedFundingSources.join(', ') : ''; // Return an empty string if no options are selected
  }
  tabChanged(event: MatTabChangeEvent) {
    this.activeTabIndex = event.index;
  }
}